import { useLocation } from "react-router-dom";

const Main = ({ children }) => {
  const location = useLocation();
  const routes = [
    "/seller-overview",
    "/seller-inventory",
    "/seller-sales",
    "/seller-wallet",
    "/seller-profile",
  ].includes(location.pathname);
  return (
    <main className={`mt-20 ${routes ? "seller-hub-content-area absolute right-0 " : ""}`}>
      {children}
    </main>
  );
};

export default Main;
